import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container} from '@modifi/ui'

import BasicCard from './BasicCard'
import {BasicCardsContainer} from './styles'
import {DefaultComponentWrapper} from '../common'
import DefaultCarosel from '../../common-components/default-carousel'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      headline: PropTypes.string,
      description: PropTypes.string,
    }).isRequired
  ),
  imageRatio: PropTypes.string,
}
const defaultProps = {
  cards: [],
  // imageRatio 11 represents ratio 1:1. Since ButterCMS doesn't support color(:), hence
  // it returns 11 as imageRatio instead of 1:1
  imageRatio: '11',
}

export type CardsCarouselProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const CardsCarousel: React.FC<CardsCarouselProps> = ({cards, imageRatio}) => (
  <BasicCardsContainer fluid>
    <Container>
      <DefaultComponentWrapper>
        <DefaultCarosel indicatorPosition="left" cardAlignment="left" containerOverflow>
          {(cards ?? []).map((cardDetails, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <BasicCard key={i} {...cardDetails} imageRatio={imageRatio} />
          ))}
        </DefaultCarosel>
      </DefaultComponentWrapper>
    </Container>
  </BasicCardsContainer>
)

CardsCarousel.propTypes = propTypes

CardsCarousel.defaultProps = defaultProps

export default CardsCarousel
